const Roles = {
  BokisAdmAdministrator: 'BokisAdmAdministrator',
  BokisAdmUser: 'BokisAdmUser',
};

export default Roles;
